import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { GridViewCellDelegate } from './grid-view-cell.delegate';

@Component({
  selector: 'ts-grid-view-cell',
  templateUrl: './grid-view-cell.component.html',
  styleUrls: ['./grid-view-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GridViewCellComponent<T> implements OnInit, OnChanges, OnDestroy {
  @Input() data: T;
  @Input() template: TemplateRef<unknown>;
  @Input() delegate: GridViewCellDelegate<T>;

  public ngOnInit(): void {
    this.delegate?.cellCreated(this.data);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const identity = this.delegate?.cellIdentity;
    if (!identity || !changes['data'] || changes['data'].firstChange) return;

    const prev = changes['data'].previousValue as T;
    const curr = changes['data'].currentValue as T;

    if (identity(prev) === identity(curr)) return;

    if (prev != null) this.delegate?.cellDestroyed(prev);
    if (curr != null) this.delegate?.cellCreated(curr);
  }

  public ngOnDestroy(): void {
    this.delegate?.cellDestroyed(this.data);
  }
}
